import React from 'react';
import { cn } from '../../lib/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  padding?: boolean;
  /** Роль для скринридера: карточка-сообщение об ошибке объявляется как alert. */
  role?: string;
}

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

export const Card: React.FC<CardProps> & {
  Header: React.FC<CardHeaderProps>;
  Body: React.FC<CardBodyProps>;
  Footer: React.FC<CardFooterProps>;
} = ({ children, className, hover = false, padding = false, role }) => {
  return (
    <div
      role={role}
      className={cn(
        'bg-white rounded-lg border border-gray-200 shadow-soft',
        'dark:bg-zinc-900 dark:border-zinc-800',
        hover && 'transition-shadow duration-base ease-snap hover:shadow-medium',
        padding && 'p-5',
        className
      )}
    >
      {children}
    </div>
  );
};

const CardHeader: React.FC<CardHeaderProps> = ({ children, className, action }) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 px-5 py-3.5 border-b border-gray-200 dark:border-zinc-800',
        className
      )}
    >
      <div className="min-w-0 flex-1">{children}</div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
};

const CardBody: React.FC<CardBodyProps> = ({ children, className }) => {
  return <div className={cn('p-5', className)}>{children}</div>;
};

const CardFooter: React.FC<CardFooterProps> = ({ children, className }) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-3 px-5 py-3 border-t border-gray-200 bg-gray-50 text-xs text-gray-500 dark:border-zinc-800 dark:bg-zinc-900 dark:text-zinc-400',
        className
      )}
    >
      {children}
    </div>
  );
};

Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export default Card;
